<template>
  <section
    v-if="exam.succeeded"
    class="container is-full is-greyish align-vertical is-centered pb-5"
  >
    <h1 class="title huge-title mt-1 has-text-success">
      <img src="/images/mail/emoji-tada.svg" />
    </h1>
    <h1
      class="has-text-success huge-title"
      v-html="$t('exam.exam-succeeded')"
    />
    <div class="subtitle is-4">
      <p
        v-html="
          $t('exam.last-attempt-results-success', {
            results: exam.result_percents,
            pass_rate: exam.pass_rate,
          })
        "
      />

      <a
        :href="exam.next_url"
        class="button is-primary is-large mt-2"
        v-html="$t('exam.proceed')"
      />
    </div>
    <a v-if="exam.is_exam_results_visible_after_exam" :href="exam.exam_results_url">
      <button v-if="exam.is_exam_results_visible_after_exam" class="button is-primary is-outlined is-medium">Check exam answers</button>
    </a>
  </section>
</template>

<script>
export default {
  name: 'Succeeded',

  props: {
    exam: { type: Object, required: true }
  }
};
</script>
